<template>
  <b-card class="pin_stats" :title="$t('stats.pin_interactions')">
    <app-echart-bar :option-data="option" />
  </b-card>
</template>

<script>
import { BCard } from "bootstrap-vue";
import AppEchartBar from "@core/components/charts/echart/AppEchartBar.vue";

export default {
  props: {
    pinpoints: {
      type: Array,
    },
    pinpoints_interactions: {
      type: Array,
    },
  },
  components: {
    BCard,
    AppEchartBar,
  },
  data() {
    return {
      option: {
        xAxis: [
          {
            type: "value",
          },
        ],
        yAxis: [
          {
            type: "category",
            data: this.pinpoints,
            splitLine: { show: false },
          },
        ],
        grid: {
          left: "130px",
          right: "30px",
          bottom: "30px",
        },
        series: [
          {
            type: "bar",
            color: "#00cfe8",
            stack: "advertising",
            data: this.pinpoints_interactions,
            barWidth: "30%",
            itemStyle: {
              barBorderRadius: [0, 10, 10, 0],
            },
          },
        ],
      },
    };
  },
  watch: {
    pinpoints: {
      handler() {
        this.option.yAxis.data = this.pinpoints;
      },
      deep: true,
    },
    pinpoints_interactions: {
      handler() {
        this.option.xAxis.data = this.pinpoints_interactions;
      },
      deep: true,
    },
  },
};
</script>
<style scoped>
.pin_stats .echarts {
  width: 100%;
  height: 500px;
}
</style>
